<template>
  <div class="sub-pavilion-button" @click="handleClick">
    <div class="sub-pavilion-button__text">{{ pavilion.childrenExhibitionName }}</div>
    <!--suppress HtmlUnknownTag -->
    <wx-open-launch-weapp
      v-if="canGoMp"
      ref="openBtn"
      class="wx-open-launch-weapp"
      :username="username"
      :path="pavilion.appUrl || '/pages/index/index'"
    >
      <!-- 必须写：占位的按钮 -->
      <script type="text/wxtag-template">
      <style>
        .ctn {
          width: 120px;
          height: 40px;
        }
      </style>
      <div class="ctn"></div>
      </script>
    </wx-open-launch-weapp>
  </div>
</template>

<script>

import { isWeChat, isWeChatMiniProgram } from '@/utils/env'
import { Toast } from 'vant'
import pavilionClick from '@/mixins/pavilion-click.js'

export default {
  name: 'SubPavilionButton',
  props: {
    pavilion: {
      type: Object,
      default: () => ({}),
    },
    toMp: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [pavilionClick],
  computed: {
    canGoMp () {
      return this.pavilion.appId && isWeChat() && !isWeChatMiniProgram()
    },
    username () {
      const { appId, originalAppId } = this.pavilion
      return originalAppId || appId
    },
  },
}
</script>

<style lang="less" scoped>
.wx-open-launch-weapp {
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: transparent;
}

.sub-pavilion-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 0.4rem;
  background: #FDD698;
  border-radius: 0.44rem;
  height: 0.88rem;
}

.sub-pavilion-button__text {
  font-family: PingFangSC-Regular;
  line-height: 0.36rem;
  text-align: center;
  font-size: 0.28rem;
  color: #C14545;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
